import React, { useState, useRef } from "react";
import styled from "styled-components";
import useNotification from "../../hooks/useNotification";

import Button from "../Button";

const StyledInviteModal = styled.div`
  position: absolute;
  z-index: 15;
  top: 28px;
  left: 0;
  padding: 20px;
  width: 100vw;
  max-width: 402px;
  background: #ffffff;
  border: 1px solid #f6f6f6;
  box-shadow: 0 0 18px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  cursor: default;

  .invite-modal__title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;
    letter-spacing: 0.005em;
    color: #232323;
    margin-bottom: 10px;
  }
  .invite-modal__subtitle {
    font-weight: 300;
    font-size: 16px;
    line-height: 20px;
    color: #232323;
    opacity: 0.8;
    margin-bottom: 15px;
  }
  .input-wrapper {
    margin-bottom: 25px;
    border: none;
    label {
      font-weight: 300;
      font-size: 14px;
      line-height: 18px;
      color: #232323;
    }
    input {
      margin-top: 7px;
      height: 40px;
      padding-left: 15px;
      background: #ffffff;
      border: 1px solid #dddddd;
      box-sizing: border-box;
      border-radius: 8px;
      width: 93%;
    }
  }
  .closeIcon {
    position: absolute;
    right: 5px;
    cursor: pointer;
  }
  .button.purple {
    min-width: 171px;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    color: #ffffff;
  }
`;

const InviteModal = ({ setInviteModalVisibility, setUseEffectTrigger }) => {
  const showNotification = useNotification();
  const [memberEmail, setMemberEmail] = useState("");

  const inviteModalRef = useRef(null);

  const handleClickOutsideItemSettings = (e) => {
    const path = e.path || (e.composedPath && e.composedPath());
    if (!path.includes(inviteModalRef.current)) {
      setInviteModalVisibility(false);
    }
  };

  React.useEffect(() => {
    document.body.addEventListener("click", handleClickOutsideItemSettings);
    return function cleanup() {
      document.body.removeEventListener(
        "click",
        handleClickOutsideItemSettings
      );
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchInvite = () => {
    fetch("https://engine.keysforweb.com/wp-json/bda/v1/invite-user", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${
          localStorage.getItem("token") || sessionStorage.getItem("token")
        }`,
      },
      body: JSON.stringify({
        email: memberEmail,
      }),
    })
      .then((resp) => resp.json())
      .then((data) => {
        console.log(data);
        if (data.status === "success") {
          showNotification(
            "success",
            "Invite sent",
            "Member of your team has been invited",
            2200
          );
          setInviteModalVisibility(false);
        } else if (data.code === "no_free_seats_to_send_new_invitation") {
          showNotification(
            "error",
            "Cannot send this invitation",
            "You have run out of seats in the team",
            2200
          );
        } else if (data.code === "rest_invalid_param") {
          showNotification(
            "error",
            "Cannot send invitation",
            "Wrong email",
            2200
          );
        } else if (data.code === "user_already_registered") {
          showNotification(
            "error",
            "Cannot send invitation",
            data.message,
            2200
          );
        }
      })
      .finally(() => {
        setUseEffectTrigger((prev) => prev + 1);
        setMemberEmail("");
      });
  };

  return (
    <StyledInviteModal ref={inviteModalRef}>
      <svg
        className={"closeIcon"}
        onClick={(e) => {
          e.stopPropagation();
          setInviteModalVisibility(false);
        }}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.99692 20C7.34485 20.0024 4.8007 18.9496 2.9254 17.0739C1.05009 15.1981 -0.00238199 12.6533 4.04814e-06 10.0006V9.80059C0.0817668 5.79305 2.54702 2.22119 6.26443 0.724184C9.98185 -0.772822 14.2337 0.0940545 17.0687 2.927C19.9303 5.78691 20.7868 10.0899 19.2384 13.828C17.6901 17.5661 14.0421 20.0024 9.99692 20ZM9.99693 11.4105L11.8812 13.2952C12.2705 13.6846 12.9018 13.6846 13.2911 13.2952C13.6803 12.9059 13.6803 12.2749 13.2911 11.8856L11.4065 10.0006L13.2911 8.11552C13.6803 7.72625 13.6803 7.09522 13.2911 6.70595C12.9018 6.31654 12.2705 6.31654 11.8812 6.70595L9.99693 8.59066L8.11268 6.70595C7.72337 6.31654 7.09207 6.31654 6.70276 6.70595C6.31359 7.09522 6.31359 7.72625 6.70276 8.11551L8.58736 10.0006L6.70283 11.8856C6.31362 12.2749 6.31362 12.906 6.70283 13.2953C7.09213 13.6847 7.72338 13.6847 8.11275 13.2954L9.99693 11.4115V11.4105Z"
          fill="#C2C5CB"
        />
      </svg>
      <div className="invite-modal__title">Invite New Team Member</div>
      <div className="invite-modal__subtitle">
        Send invitation link to the team member via email.
      </div>
      <div className="input-wrapper">
        <label htmlFor="Email">Email</label>
        <input
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              fetchInvite();
            }
          }}
          onChange={(e) => setMemberEmail(e.target.value)}
          value={memberEmail}
          type="text"
          placeholder={"E.g., john@email.com"}
        />
      </div>
      <Button
        onClick={fetchInvite}
        color={"purple"}
        text={"Send Invitation Link"}
      />
    </StyledInviteModal>
  );
};

export default InviteModal;
